import { render } from "./ShareHolderDailyDeposit.vue?vue&type=template&id=1973a164"
import script from "./ShareHolderDailyDeposit.vue?vue&type=script&lang=js"
export * from "./ShareHolderDailyDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__